import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['dollar', 'cents', 'input'];
    
  connect() {
    this.dollarTarget.value = this.inputTarget.value
    this.createDivForVariableWidth()
    this.calculateWidth()
  }
  
  update() {
    this.formatValue()
    this.calculateWidth()
  }
  
  calculateWidth() {
    this.widthDiv.innerHTML = this.dollarTarget.value
    this.dollarTarget.style.width = this.widthDiv.offsetWidth + 10 + 'px'
  }
  
  formatValue() {
    const currentValue = this.dollarTarget.value
    let formattedValue
    
    if (currentValue[0] == '0') {
      formattedValue = currentValue.substring(1)
      this.dollarTarget.value = formattedValue
    } else if (currentValue.length === 0) {
      formattedValue = 0
      this.dollarTarget.value = 0
    } else {
      formattedValue = currentValue.replace(',', '')
    }
    
    this.inputTarget.value = formattedValue
  }
  
  createDivForVariableWidth() {
    const referenceDiv = document.createElement('div')
    const css = `font-size: ${this.styles['font-size']}; opacity: 0;
                 font-weight: ${this.styles['font-weight']}; z-index: -1; 
                 height: 0; display: inline-block; position: absolute;`
                 
    referenceDiv.setAttribute('id', 'widthDiv')
    referenceDiv.style.cssText = css
    this.element.append(referenceDiv)
    this.data.widthDiv = document.getElementById('widthDiv')
  }
  
  get styles() {
    return window.getComputedStyle(this.dollarTarget)
  }
  
  get widthDiv() {
    return this.data.widthDiv
  }
  
  set widthDiv(value) {
    return this.data.widthDiv = value
  }
}